import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classnames from 'classnames';
import { Radio } from 'synfrastructure';
import VideoHint from './VideoHint';
import Icon from '../../../common/icons/Icon';
import ToggleScaffold from '../../../common/forms/ToggleScaffold';

class Quiz extends Component {
  static propTypes = {
    label: PropTypes.string,
    onSubmit: PropTypes.func.isRequired,
    quiz: PropTypes.object,
    title: PropTypes.string,
    videoId: PropTypes.string,
  };

  static defaultProps = {
    title: 'Quiz',
    label: 'Take Quiz',
  };

  state = {
    answers: [],
    currentQuestion: 0,
    currentAnswer: null,
    displayVideoHint: false,
  };

  toggleVideoHintOpen = () => {
    this.setState(state => ({ displayVideoHint: !state.displayVideoHint }));
  };

  handleAnswerQuestion = () => {
    const { answers, currentQuestion, currentAnswer } = this.state;
    const { quiz, onSubmit } = this.props;
    const nextAnswers = [...answers];
    let nextQuestion = currentQuestion + 1;

    if (currentQuestion < answers.length) {
      nextAnswers[currentQuestion] = currentAnswer;
    } else if (currentQuestion === answers.length) {
      nextAnswers.push(currentAnswer);
    } else {
      nextQuestion = answers.length;
    }

    if (nextQuestion === quiz.get('questions').size) {
      onSubmit(quiz.get('id'), nextAnswers);
      this.setState({
        answers: [],
        currentQuestion: 0,
        currentAnswer: null,
        checkedRadio: null,
        displayVideoHint: false,
      });
    } else {
      this.setState({
        answers: nextAnswers,
        currentAnswer: null,
        checkedRadio: null,
        currentQuestion: nextQuestion,
        displayVideoHint: false,
      });
    }
  };

  handleSetAnswer = currentAnswer => {
    this.setState({ currentAnswer });
  };

  handleSetQuestion = currentQuestion => {
    const currentAnswer = currentQuestion < this.state.answers.length ? this.state.answers[currentQuestion] : null;
    this.setState({
      currentQuestion,
      currentAnswer,
      displayVideoHint: false,
    });
  };

  renderQuestion = question => {
    const { currentAnswer, currentQuestion, displayVideoHint } = this.state;
    const hasRightAnswer = question.has('correct_answer') && question.get('correct_answer') === currentAnswer;
    const hasWrongAnswer = question.has('correct_answer') && question.get('correct_answer') !== currentAnswer;
    const hasMinScore = this.props.quiz.get('min_score') > 0;
    const buttonDisabled =
      currentAnswer === null || (question.has('correct_answer') && question.get('correct_answer') !== currentAnswer);

    return (
      <div>
        <div className="quiz__body">
          <div className="quiz__body__question">
            {currentQuestion + 1}. {question.get('text')}
          </div>
          {question
            .get('answers')
            .toArray()
            .map((answer, index) => {
              const isCurrent = currentAnswer === index;
              return (
                <div key={answer + index} className="quiz__body__answer">
                  <ToggleScaffold
                    label={answer}
                    className={classnames({
                      checked: isCurrent,
                      wrong: isCurrent && hasWrongAnswer && !hasMinScore,
                    })}
                  >
                    <Radio
                      id={answer}
                      value={answer}
                      checked={isCurrent}
                      readOnly
                      onClick={this.handleSetAnswer.bind(this, currentAnswer === index ? null : index)}
                    />
                  </ToggleScaffold>
                </div>
              );
            })}
        </div>
        {typeof question.get('video_hint') === 'number' ? (
          <div className="quiz__video-hint">
            <VideoHint
              initialTime={question.get('video_hint')}
              toggleVideoHintOpen={this.toggleVideoHintOpen}
              videoHintOpen={displayVideoHint}
            />
          </div>
        ) : null}
        <div
          className={classnames({
            quiz__submit: true,
            'quiz__submit--correct': hasRightAnswer && !hasMinScore,
            'quiz__submit--wrong': currentAnswer !== null && hasWrongAnswer && !hasMinScore,
          })}
        >
          <div>
            {currentAnswer !== null && !hasMinScore ? (
              <div className="quiz__submit__status">
                <Icon icon={hasWrongAnswer ? 'Close' : 'CheckmarkCircleOutline'} />
                <span>{hasWrongAnswer ? 'Try Again!' : 'Correct!'}</span>
              </div>
            ) : null}
          </div>
          <button
            type="button"
            disabled={buttonDisabled}
            className={classnames({
              button: true,
              'button--theme--white': true,
            })}
            onClick={this.handleAnswerQuestion}
          >
            Submit
          </button>
        </div>
      </div>
    );
  };

  render() {
    const { quiz, title } = this.props;
    const { answers, currentQuestion } = this.state;

    return (
      <div className="quiz__container">
        <div className="quiz">
          <div className="quiz__header">
            <h1>{title}</h1>
            <div className="quiz__stepper">
              {quiz
                .get('questions')
                .toArray()
                .map((question, i) => (
                  <button
                    key={i}
                    type="button"
                    className={`quiz__stepper-button ${currentQuestion === i ? 'quiz__stepper-button--active' : ''}`}
                    disabled={i > answers.length}
                    onClick={this.handleSetQuestion.bind(this, i)}
                  >
                    {i + 1}
                  </button>
                ))}
            </div>
          </div>
          {this.renderQuestion(quiz.getIn(['questions', currentQuestion]))}
        </div>
      </div>
    );
  }
}

export default Quiz;



// WEBPACK FOOTER //
// ./src/subscription/courses/components/Quiz.js